import React, { useContext, useEffect, useState } from "react";
import { MarketContext } from "../../../context/MarketContext";
import classes from "./AccountSummary.module.css";
import useWindowDimensions from "../../../hooks/getWindowDimensions";
import { InfoCard } from "../../LeaderboardContent/LeaderboardContent";
import CrownIcon from "../../../icon/CrownIcon";
import MedalIcon from "../../../icon/MedalIcon";
import HonourStarIcon from "../../../icon/HonourStarIcon";
import { env } from "../../../constants/env";

const filteredData = [
  { rank: 1, user: "Shaun O.", balance: "750 $PROP" },
  { rank: 2, user: "Jose V.", balance: "550 $PROP" },
  { rank: 3, user: "Paula O.", balance: "450 $PROP" },
  { rank: 4, user: "Moe A .", balance: "250 $PROP" },
  { rank: 5, user: "Klein M.", balance: "100 $PROP" },
];

const checklistItems = [
  {
    text: "⚡ Join the Arena, trade while waiting for the next cohort",
  },
  {
    text: "💰 Use $PROP to trade GOLD.pf and BTC/USD.pf in short-term rounds (30s–1m)",
  },
  {
    text: "📈 Earn up to 80% returns on each winning trade",
  },
  {
    text: (
      <>
        🏆 Redeem $PROP for discounts, funded accounts, or guaranteed cohort
        spots.{" "}
        <a href="https://docs.propfunding.com/proparena/how-the-arena-works" target="_blank">
          Learn more
        </a>
      </>
    ),
  },
];

const AccountSummary = () => {
  const { balance } = useContext(MarketContext);
  const [isOpen, setIsOpen] = useState(false);

  const { width } = useWindowDimensions();
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
  const fetchLeaderboard = () => {
    fetch(`${env.apiUrl}/api/user/arena/leaderboard`)
      .then((res) => res.json())
      .then(setLeaderboard)
      .catch(() => setLeaderboard(filteredData)); // fallback
  };

  // Fetch immediately on load
  fetchLeaderboard();

  // Refresh every 5 seconds
  const interval = setInterval(fetchLeaderboard, 5000);

  // Cleanup interval
  return () => clearInterval(interval);
}, []);

  const isDesktop = width >= 768;

  return (
    <div className={`${classes.accountSummary}`}>
      <div
        className={`${classes.card} ${classes.balance} d-flex flex-column align-items-center justify-content-center`}
      >
        {/* ✅ Format balance with commas */}
        <h3>{balance.toLocaleString()} $PROP</h3>
        <p>Balance</p>
      </div>
      <InfoCard
        title="🕹️ How it Works:"
        items={checklistItems}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isDesktop={isDesktop}
        className={classes.infoCard}
        customCloseIcon
      />
      <div
        className={`${classes.card} ${classes.leaderboard}`}
      >
        <h4>Leaderboard</h4>
      <div className="table-responsive">
        <table className={classes.table}>
          <thead>
            <tr>
              <th>Rank</th>
              <th>User</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.map((entry, i) => {
              
              const rowClass = "";

              const icon =
                entry.rank === 1 ? (
                  <CrownIcon />
                ) : entry.rank === 2 ? (
                  <MedalIcon />
                ) : entry.rank === 3 ? (
                  <HonourStarIcon />
                ) : null;

              return (
                <tr
                  key={entry.rank}
                  className={`${rowClass} ${
                    entry.blurred
                      ? classes.blurredRow
                      : entry.dark
                      ? classes.darkRow
                      : ""
                  }`}
                >
                  <td
                    className={`${classes.rankCell} ${
                      entry.rank === 1
                        ? classes.top1
                        : entry.rank === 2
                        ? classes.top2
                        : entry.rank === 3
                        ? classes.top3
                        : classes.bottomRank
                    }`}
                  >
                    <div className="d-flex align-items-center gap-2">
                      {icon}
                      {entry.rank}
                    </div>
                  </td>
                  <td>
                    {entry.user}
                  </td>
                  <td ><span className={classes.balanceCell}>{entry.balance}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
};

export default AccountSummary;
